import React, { useRef, useState, useEffect } from "react";
import { rem } from "polished";
import styled, { css } from "styled-components";
import mq from "../../../helpers/media-queries";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import X from "../../../assets/img/x.png";
import RenderContainer from "../../RenderContainer/RenderContainer";
import RenderIframe from "../Wooden/RenderIframe";
import { ConfigurationProvider } from "../Wooden/ConfigurationContext";
import { SketchfabProvider } from "../../Sketchfab/SketchfabContext";

// Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";

SwiperCore.use([Pagination]);

const Wrap = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100vw;
	background-color: #fff;
	height: 100vh;
	z-index: 5;
	display: none;

	${mq("sm", "min")} {
		display: none;
	}

	${(props) =>
		props.open &&
		css`
			display: block;
		`}

	.swiper-container {
		height: calc(100% - 47px);
		padding-bottom: 65px;
		position: relative;
	}

	.swiper-pag {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		display: flex;
		align-items: center;
		padding: ${rem(10)};
		border-top: 1px solid #dbdbdb;
		min-height: 65px;
		overflow-x: scroll;
	}

	.swiper-pagination-bullet {
		width: 40px;
		height: 40px;
		min-width: 40px;
		min-height: 40px;
		border-radius: 50%;
		opacity: 1;
		background-position: center center;
		background-size: cover;
		background-repeat: no-repeat;
		background-color: #fff;
		cursor: pointer;
	}

	.swiper-slide img {
		height: 100%;
		object-fit: cover;
	}

	.swiper-pagination-bullet-active {
		background-color: #fff;
		border: 1px solid #433129;
	}

	img {
		width: 100%;
	}
`;

const TopBar = styled.div`
	padding: 15px;
	border-bottom: 1px solid #dbdbdb;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #433129;
	font-weight: 400;
	font-size: 18px;

	img {
		width: 14px;
		curor: pointer;
	}
`;

const Pinch = styled.button`
	position: absolute;
	right: 20px;
	top: 450px;
	font-size: 15px;
	line-height: 130%;
	width: 124px;
	height: 34px;
	background: #433129;
	border-radius: 4px;
	color: #ffffff;
	z-index: 2;
	border: 0;
	display: none;

	${(props) =>
		props.show &&
		css`
			display: block;
		`}
`;

const Popup = ({ data, open, setOpen, modelId, initialSlide, color }) => {
	const viewerRef = useRef(null);
	const [showButton, setShowButton] = useState(true);

	if (open) {
		document.body.style.overflow = "hidden";
	} else {
		document.body.style.overflow = "unset";
	}

	console.log("swioper", Pagination);

	function showImage(item) {
		let img;
		if (color === 1 && item.secondImage) {
			img = item.secondImage;
		} else {
			img = item.image;
		}
		return img;
	}

	return (
		<Wrap
			open={open}
			onClick={() => setShowButton(false)}
			onTouchStart={() => setShowButton(false)}
		>
			<TopBar>
				<p>Deluxe Premium Acrylic Hot Tub</p>
				<img
					src={X}
					onClick={() => {
						setOpen(false);
						setShowButton(true);
					}}
				/>
			</TopBar>
			<Swiper
				key={color}
				style={open === "slider" ? { display: "block" } : { display: "none" }}
				spaceBetween={35}
				pagination={{
					clickable: true,
					el: ".swiper-pag",
					renderBullet: function (index, className) {
						console.log("checkdiss");
						return `<span style="background-image: url(${
							color === 1 && data[index].secondImage
								? data[index].secondImage
								: data[index].image
						});" class="${className}"></span>`;
					},
				}}
				slidesPerView={1}
				initialSlide={Number(initialSlide)}
			>
				{data.map((item, index) => (
					<SwiperSlide key={index}>
						<img src={showImage(item)} alt="" />
					</SwiperSlide>
				))}
				<div className="swiper-pag"></div>
				<Pinch show={showButton}>Pinch to zoom</Pinch>
			</Swiper>
			<ConfigurationProvider
				style={open === "360" ? { display: "block" } : { display: "none" }}
			>
				<SketchfabProvider modelUID={modelId} viewerRef={viewerRef}>
					<RenderContainer fullHeight={true} relative={false}>
						<RenderIframe viewerRef={viewerRef} />
					</RenderContainer>
				</SketchfabProvider>
			</ConfigurationProvider>
		</Wrap>
	);
};

export default Popup;
